<template>
	<Dialog :open="isOpen" @update:open="$emit('update:isOpen', $event)">
		<DialogContent class="max-w-md" :disable-overlay-close="true" @close="handleClose">
			<DialogHeader>
				<DialogTitle>
					<span class="flex items-center gap-2">
						<span class="fa-light fa-edit text-blue-500"></span>
						Edit Template
					</span>
				</DialogTitle>
				<DialogDescription>Update template details</DialogDescription>
			</DialogHeader>

			<div class="mt-4 space-y-4">
				<div class="formGroup w-full">
					<p class="filter-label">Template Name</p>
					<input
						v-model="editedTemplate.name"
						type="text"
						placeholder="Template Name"
						class="w-full focus:border-blue-500 focus:ring-blue-500"
					/>
				</div>

				<div class="formGroup w-full">
					<p class="filter-label">Description</p>
					<textarea
						v-model="editedTemplate.description"
						placeholder="Template Description"
						class="min-h-[100px] w-full focus:border-blue-500 focus:ring-blue-500"
						rows="4"
					></textarea>
				</div>
			</div>

			<DialogFooter class="mt-6 flex justify-between">
				<div>
					<button class="jmiBtn red" @click="confirmDelete">Delete Template</button>
				</div>
				<div class="flex gap-2">
					<button class="jmiBtn gray" @click="handleClose">Cancel</button>
					<button class="jmiBtn blue" :disabled="!canSave" @click="saveTemplate">Save</button>
				</div>
			</DialogFooter>
		</DialogContent>
	</Dialog>
</template>

<script>
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog'
import flowTemplatesApi from '../scripts/flowtemplates/flowtemplates.api'

export default {
	components: {
		Dialog,
		DialogContent,
		DialogHeader,
		DialogTitle,
		DialogDescription,
		DialogFooter
	},
	props: {
		isOpen: {
			type: Boolean,
			default: false
		},
		template: {
			type: Object,
			default: null
		}
	},

	emits: ['update:isOpen', 'template-updated', 'template-deleted'],

	data() {
		return {
			editedTemplate: {
				id: null,
				name: '',
				description: ''
			}
		}
	},

	computed: {
		canSave() {
			return this.editedTemplate.name.trim() !== ''
		}
	},

	watch: {
		template: {
			immediate: true,
			handler(template) {
				if (template) {
					this.editedTemplate = {
						id: template.id,
						name: template.name || '',
						description: template.description || ''
					}
				}
			}
		}
	},

	methods: {
		handleClose() {
			this.$emit('update:isOpen', false)
		},

		async saveTemplate() {
			try {
				if (!this.canSave) return

				const updatedTemplate = await flowTemplatesApi.update(this.editedTemplate)

				this.$emit('template-updated', updatedTemplate)

				this.handleClose()
			} catch (error) {
				console.error('Error updating template:', error)

				this.$swal({
					title: 'Error',
					text: 'Failed to update template. Please try again.',
					icon: 'error',
					confirmButtonText: 'OK'
				})
			}
		},

		confirmDelete() {
			this.$swal({
				title: 'Delete Template',
				text: `Are you sure you want to delete the template "${this.editedTemplate.name}"?`,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Delete',
				cancelButtonText: 'Cancel'
			}).then((result) => {
				if (result.isConfirmed) {
					this.deleteTemplate()
				}
			})
		},

		async deleteTemplate() {
			try {
				await flowTemplatesApi.delete(this.editedTemplate.id)

				this.$emit('template-deleted', this.editedTemplate.id)

				this.handleClose()
			} catch (error) {
				console.error('Error deleting template:', error)

				this.$swal({
					title: 'Error',
					text: 'Failed to delete template. Please try again.',
					icon: 'error',
					confirmButtonText: 'OK'
				})
			}
		}
	}
}
</script>
